import React, { useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';

import { calculatePercentage } from 'functions/testResult';
import { ProgressBarComponent, ProgressBar, ResultText, TestInformationText } from './styles';

export default function ResultBar({ ticket, test }) {
  const [percentage, setPercentage] = useState(0);
  const [label, setLabel] = useState('');
  const [tooltip, setTooltip] = useState('');

  useEffect(() => {
    if (ticket.processing) {
      setLabel('');
      setPercentage(0);
      return setTooltip('This might take a few minutes');
    }
    if (!ticket.completedAt) {
      setLabel('');
      setPercentage(0);
      return setTooltip('There is no test result for this test yet');
    }

    let percentage = calculatePercentage(test, ticket, false, true);
    let roundOffPercentage = Math.round(percentage);
    setPercentage(roundOffPercentage);
    let scale;

    if (test?.adaptiveTest) {
      setLabel(`${roundOffPercentage}%`);
      setTooltip(
        'The candidate was better than ' + roundOffPercentage + '% <br/>of the candidates that have taken the test.'
      );
    } else {
      scale = ticket.totalQuestions ? ticket.totalQuestions : test.scale;
      setLabel(ticket.result + '/' + scale);
      setTooltip('The candidate test result score was <br/> ' + ticket.result + '/' + scale + '.');
    }
  }, [ticket, test]);

  return (
    <ProgressBarComponent data-tooltip-id={ticket._id} data-tooltip-html={tooltip}>
      <ResultText>{label}</ResultText>
      <Tooltip id={ticket._id} place="top" />
      <ProgressBar className="progress progress-bar-success" value={percentage} max="100" />
      {ticket.language && ticket.submitted && (
        <TestInformationText>Used: {ticket.languageVersion || ticket.language}</TestInformationText>
      )}
    </ProgressBarComponent>
  );
}
